export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12871.764fb1c7.jpg";